const INITIAL_STATE = {
  vouchers: [],
  voucher: {},
  situation: 'PENDENTE_BONIFICACAO',
  filterDate: {
    begin: '',
    end: ''
  }
}

export const Creators = {
  resetVouches: () => ({
    type: 'RESET'
  })
};

export default function vouchersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_VOUCHERS':
      return {
        ...state,
        vouchers: action.vouchers
      }
    case 'VOUCHER_SELECTED':
      return {
        ...state,
        voucher: action.voucher
      }
    case 'SET_DATE': 
      return {
        ...state,
        filterDate: {
          begin: action.begin, 
          end: action.end
        }
      }
    case 'CHANGE_SITUATION': 
      return {
        ...state,
        situation: action.situation
      }
    case 'RESET':
      return {
        vouchers: [],
        voucher: {},
        filterDate: {
          begin: '',
          end: ''
        }
      }
    default:
      return state;
  }
}